export const types = {
  // Async
  FETCH_WARDROBE_PRODUCTS: "FETCH_WARDROBE_PRODUCTS",
  FETCH_WEEK_SELECTION: "FETCH_WEEK_SELECTION",
  FETCH_START_SHOP_PRODUCTS: "FETCH_START_SHOP_PRODUCTS",
  FETCH_SHOP_PRODUCTS: "FETCH_SHOP_PRODUCTS",
  FETCH_SAVED_PRODUCTS: "FETCH_SAVED_PRODUCTS",
  FETCH_FOLLOWING_BRANDS_ASYNC: "FETCH_FOLLOWING_BRANDS_ASYNC",
  FETCH_FOLLOWING_STORES_ASYNC: "FETCH_FOLLOWING_STORES_ASYNC",
  FOLLOW_USER_ASYNC: "FOLLOW_USER_ASYNC",
  UNFOLLOW_USER_ASYNC: "UNFOLLOW_USER_ASYNC",
  FETCH_SPINS_ASYNC: "FETCH_SPINS_ASYNC",
  FETCH_WEARABLE_DATA_ASYNC: "FETCH_WEARABLE_DATA_ASYNC",
  FETCH_ART_DATA_ASYNC: "FETCH_ART_DATA_ASYNC",
  FETCH_PRODUCT_BY_TOKEN: "FETCH_PRODUCT_BY_TOKEN",
  FETCH_PRODUCT_BY_SLUG: "FETCH_PRODUCT_BY_SLUG",
  FETCH_TRANSACTION_HISTORY: "FETCH_TRANSACTION_HISTORY",
  FETCH_TOKENIZED_BRAND_INFO: "FETCH_TOKENIZED_BRAND_INFO",
  CHECK_TAKEBACKRENT: "CHECK_TAKEBACKRENT",
  TAKEBACKRENT: "TAKEBACKRENT",
  FETCH_PROFILE_DATA: "FETCH_PROFILE_DATA",
  FETCH_WORLDS_DATA: "FETCH_WORLDS_DATA",
  FETCH_VOUCHERS_DATA: "FETCH_VOUCHERS_DATA",
  CHECK_VOUCHER_CODE: "CHECK_VOUCHER_CODE",
  DELETE_TRANSACTION_MEMORY: "DELETE_TRANSACTION_MEMORY",
  FETCH_GALLERY_IMAGES: "FETCH_GALLERY_IMAGES",
  FETCH_PROFILES_TO_SWITCH_POPUP: "FETCH_PROFILES_TO_SWITCH_POPUP",
  FETCH_PROFILES_FOR_SWITCH_POPUP: "FETCH_PROFILES_FOR_SWITCH_POPUP",
  SWITCH_PROFILE_WHEN_LOGIN: "SWITCH_PROFILE_WHEN_LOGIN",

  // Sync
  FETCH_PROFILE_IS_LOADING: "FETCH_PROFILE_IS_LOADING",
  FETCH_WARDROBE_SUCCEEDED: "FETCH_WARDROBE_SUCCEEDED",
  FETCH_WARDROBE_FAILED: "FETCH_WARDROBE_FAILED",
  FETCH_WEEK_SELECTION_SUCCEEDED: "FETCH_WEEK_SELECTION_SUCCEEDED",
  FETCH_WEEK_SELECTION_FAILED: "FETCH_WEEK_SELECTION_FAILED",
  FETCH_SHOP_PRODUCTS_SUCCEEDED: "FETCH_SHOP_PRODUCTS_SUCCEEDED",
  FETCH_SHOP_PRODUCTS_FAILED: "FETCH_SHOP_PRODUCTS_FAILED",
  FETCH_SAVED_PRODUCTS_AND_UPDATE_SUCCEEDED:
    "FETCH_SAVED_PRODUCTS_AND_UPDATE_SUCCEEDED",
  FETCH_SAVED_PRODUCTS_AND_ADD_SUCCEEDED:
    "FETCH_SAVED_PRODUCTS_AND_ADD_SUCCEEDED",
  FETCH_SAVED_PRODUCTS_FAILED: "FETCH_SAVED_PRODUCTS_FAILED",
  FETCH_FOLLOWING_BRANDS_SUCCEEDED: "FETCH_FOLLOWING_BRANDS_SUCCEEDED",
  FETCH_FOLLOWING_BRANDS_FAILED: "FETCH_FOLLOWING_BRANDS_FAILED",
  FOLLOW_USER_SUCCEEDED: "FOLLOW_USER_SUCCEEDED",
  FOLLOW_USER_FAILED: "FOLLOW_USER_FAILED",
  UNFOLLOW_USER_SUCCEEDED: "FOLLOW_USER_SUCCEEDED",
  UNFOLLOW_USER_FAILED: "FOLLOW_USER_FAILED",
  FETCH_SPINS_SUCCEEDED: "FETCH_SPINS_SUCCEEDED",
  FETCH_SPINS_FAILED: "FETCH_SPINS_FAILED",
  FETCH_START_SHOP_PRODUCTS_SUCCEEDED: "FETCH_START_SHOP_PRODUCTS_SUCCEEDED",
  FETCH_FOLLOWING_STORES_SUCCEEDED: "FETCH_FOLLOWING_STORES_SUCCEEDED",
  FETCH_FOLLOWING_STORES_FAILED: "FETCH_FOLLOWING_STORES_FAILED",
  REMOVE_FOLLOWING: "REMOVE_FOLLOWING",
  REMOVE_SAVED: "REMOVE_SAVED",
  REMOVE_SPINS: "REMOVE_SPINS",
  REMOVE_SHOP_PRODUCTS: "REMOVE_SHOP_PRODUCTS",
  BRAND_TAB_KIND: "BRAND_TAB_KIND",
  USUAL_TAB_KIND: "USUAL_TAB_KIND",
  SAVE_SCROLL_STATE: "SAVE_SCROLL_STATE",
  SET_PAGE_NUMBER: "SET_PAGE_NUMBER",
  SET_GIVEBACK_DATA: "SET_GIVEBACK_DATA",
  SET_PRODUCT_INFO: "SET_PRODUCT_INFO",
  SET_PRODUCT_TOKEN: "SET_PRODUCT_TOKEN",
  SET_PRODUCT_ERROR: "SET_PRODUCT_ERROR",
  SET_PROFILE_ERROR: "SET_PROFILE_ERROR",
  SET_TRANSACTION_HISTORY: "SET_TRANSACTION_HISTORY",
  SET_TOKENIZED_BRAND_INFO: "SET_TOKENIZED_BRAND_INFO",
  SET_PROFILE_DATA: "SET_PROFILE_DATA",
  SET_WORLDS_DATA: "SET_WORLDS_DATA",
  SET_VOUCHERS_DATA: "SET_VOUCHERS_DATA",
  SET_DISCOUNT_FOR_CERTAIN_PRODUCT: "SET_DISCOUNT_FOR_CERTAIN_PRODUCT",
  SET_IS_PRODUCT_OPEN: "SET_IS_PRODUCT_OPEN",
  DELETE_MEMORY_LOCALLY: "DELETE_MEMORY_LOCALLY",
  SHOULD_UPDATE_VAULT: "SHOULD_UPDATE_VAULT",
  SET_GALLERY_IMAGES: "SET_GALLERY_IMAGES",
  SET_GALLERY_IMAGE_ID_TO_SCROLL: "SET_GALLERY_IMAGE_ID_TO_SCROLL",
  SET_PROFILES_TO_SWITCH_POPUP: "SET_PROFILES_TO_SWITCH_POPUP",
  FETCH_START_ARTS_PRODUCTS: "FETCH_START_ARTS_PRODUCTS",
  FETCH_START_ARTS_PRODUCTS_SUCCEED: "FETCH_START_ARTS_PRODUCTS_SUCCEED",
  FETCH_ARTS_PRODUCTS: "FETCH_ARTS_PRODUCTS",
  FETCH_ARTS_PRODUCTS_SUCCEED: "FETCH_ARTS_PRODUCTS_SUCCEED",
  SET_ARTS_PAGE_NUMBER: "SET_ARTS_PAGE_NUMBER",

  FETCH_LEADERBOARD_START: "FETCH_LEADERBOARD_START",
  FETCH_LEADERBOARD_SUCCESS: "FETCH_LEADERBOARD_SUCCESS",
  FETCH_LEADERBOARD_FAILURE: "FETCH_LEADERBOARD_FAILURE",

  FETCH_PLAYER_ACTIVITY_START: "FETCH_PLAYER_ACTIVITY_START",
  FETCH_PLAYER_ACTIVITY_SUCCESS: "FETCH_PLAYER_ACTIVITY_SUCCESS",
  FETCH_PLAYER_ACTIVITY_FAILURE: "FETCH_PLAYER_ACTIVITY_FAILURE",

  FETCH_ALL_PLAYERS_START: "FETCH_ALL_PLAYERS_START",
  FETCH_ALL_PLAYERS_SUCCESS: "FETCH_ALL_PLAYERS_SUCCESS",
  FETCH_ALL_PLAYERS_FAILURE: "FETCH_ALL_PLAYERS_FAILURE",

  FETCH_GAME_WINNERS_START: "FETCH_GAME_WINNERS_START",
  FETCH_GAME_WINNERS_SUCCESS: "FETCH_GAME_WINNERS_SUCCESS",
  FETCH_GAME_WINNERS_FAILURE: "FETCH_GAME_WINNERS_FAILURE",

  FETCH_TOKEN_TAG_GAME_STATUS: "FETCH_TOKEN_TAG_GAME_STATUS",
  SET_TOKEN_TAG_GAME_STATUS: "SET_TOKEN_TAG_GAME_STATUS",

  // Business profile creation flow (transient UI state)
  SET_BUSINESS_CREATED: "SET_BUSINESS_CREATED",
  CLEAR_BUSINESS_CREATED: "CLEAR_BUSINESS_CREATED",
  RESET_TAB_SELECTION_STATE: "RESET_TAB_SELECTION_STATE",

  // Profile Page Refactor (New Flow)
  RESET_PROFILE_PAGE: "RESET_PROFILE_PAGE",
  LOAD_PROFILE_PAGE_START: "LOAD_PROFILE_PAGE_START",
  LOAD_PROFILE_PAGE_SUCCEEDED: "LOAD_PROFILE_PAGE_SUCCEEDED",
  LOAD_PROFILE_PAGE_FAILED: "LOAD_PROFILE_PAGE_FAILED",
  UPDATE_SWITCHABLE_PROFILE_STATUS: "UPDATE_SWITCHABLE_PROFILE_STATUS",
};
